type TimeUnit = 'second' | 'minute' | 'hour';

export class ScheduledCallbackRunner {
  private requestId: null | number = null;

  private lastSecond = -1;

  constructor(
    private readonly callback: (date: Date) => any,
    private timeUnit: TimeUnit,
    private getDate: () => Date,
  ) {}

  public run() {
    if (!this.requestId) {
      this.requestId = requestAnimationFrame(this.tick);
    }
  }

  public stop() {
    if (this.requestId) {
      cancelAnimationFrame(this.requestId);
      this.requestId = null;
    }
  }

  private tick = () => {
    const now = this.getDate();
    const currentSeconds = this.getTimeUnitValueFromDate(now);

    if (this.lastSecond !== currentSeconds) {
      this.lastSecond = currentSeconds;
      this.callback(now);
    }

    this.requestId = requestAnimationFrame(this.tick);
  };

  private getTimeUnitValueFromDate = (date: Date) => {
    switch (this.timeUnit) {
      case 'second':
        return date.getSeconds();
      case 'minute':
        return date.getMinutes();
      case 'hour':
        return date.getHours();
      default:
        throw new Error('Not Implemented');
    }
  };
}
